import { useNavigate } from 'react-router-dom';

import SidebarTrigger from '@/components/header/SidebarTrigger';
import { Sidebar, SidebarHeader, SidebarRail } from '@/components/ui/sidebar';

import NewChatButton from '../header/NewChat';
import SearchChats from './Search';
import { ThreadHistory } from './ThreadHistory';

export default function LeftSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  const navigate = useNavigate();

  return (
    <Sidebar {...props} className="border-none">
      <SidebarHeader className="py-3">
        <div className="flex justify-between items-center">
          <div className="flex flex-row gap-2 items-center min-w-0">
            <img
              src="/images/logo.png"
              alt="Logo"
              className="h-8 w-auto max-w-[120px] object-contain filter drop-shadow-[0_0_4px_rgba(255,255,255,0.9)] shrink-0"
            />
          </div>
          <div className="flex items-center">
            <SearchChats />
            <SidebarTrigger />
          </div>
        </div>
        <NewChatButton navigate={navigate} useSidebarTheme />
      </SidebarHeader>
      <ThreadHistory />
      <SidebarRail />
    </Sidebar>
  );
}
